import FormControl from '@mui/material/FormControl';

/**
 * FormControl prop presets
 * @param {any} props
 * @returns FormControl component
 */
const FormControlCustomized = props => {
	return (
		<FormControl variant='outlined' fullWidth sx={{ mt: 2 }}>
			{props.children}
		</FormControl>
	);
};
export default FormControlCustomized;
